<div class="text" #textElement>{{ text }}</div>
